import th from 'vuetify/src/locale/th.ts'

export default {
  ...th,
  action: 'จัดการ',
  preference: 'ปรับแต่ง',
  logout: 'ออกจากระบบ',
  users: 'บัญชีผู้ใช้งาน'
}
